<template>
  <div class="storeAdd">
    <div class="treeSelect-box">
      <van-tree-select :items="certificateList" :main-active-index.sync="active">
        <template #content>
          <div>
            <van-checkbox-group v-model="result" @change="checkboxChange">
              <div v-for="(item, index) in certificateList" :key="index">
                <div v-show="active == index">
                  <div v-if="item.acctGoodsVO.length != 0">
                    <div v-for="ite in item.acctGoodsVO" :key="ite.goodsId" class="checkbox-item">
                      <van-checkbox icon-size="16px" :name="ite.goodsId" shape="square" ref="checkboxes">{{ite.goodsName}}</van-checkbox>
                      <van-stepper v-model="ite.maxNumber" disabled :show-plus="false" :show-minus="false" button-size="22px" max="9999" input-width="42px"/>
                    </div>
                  </div>
                  <div v-else class="empty">
                    <img src="../../assets/images/bnodata.png" alt="">
                    <div class="desc">暂无数据</div>
                  </div>
                </div>
              </div>
            </van-checkbox-group>
          </div>
        </template>
      </van-tree-select>
    </div>
    <div>
      <van-row class="btnRow">
        <van-col span="24" class="centerText confirmText" @click.native="sureFun">选好了</van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Icon, Popup, Toast, Field, TreeSelect, Checkbox, CheckboxGroup, Stepper } from "vant";

Vue.use(Row)
  .use(Col)
  .use(Icon)
  .use(Popup)
  .use(Field)
  .use(TreeSelect)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Stepper)

export default {
  name: "storeAdd",
  components: {},
  data() {
    return {
      active: 0,
      checked: true,
      type: '', // interior内部移交；store收到入库
      index: null, // 内部移交-盘点第几家公司添加的物品
      certificateList: [],
      result: [],
      toggleState: false,
      toggleNumber: 0
    };
  },

  methods: {
    // 获取材料及其分类列表
    getGoodsList () {
      let customerId = this.$route.params.customerId
      let storeGoodsList = localStorage.getItem("storeGoodsList");
      if (storeGoodsList) {
        storeGoodsList = JSON.parse(storeGoodsList)
      }
      let params = {
        accCompanyId: this.$store.state.acctCompanyInfo.accCompanyId,
        receiverId: Object.keys(this.$store.state.userInfo).length>0 && this.$store.state.userInfo.staff.staffId || '',
        customerId: customerId
      }
      this.$http
        .post("/mini/user/goods/summary/queryGoodsStoreHold", params)
        .then(res => {
          if (res.data.code == 200) {
            let newList = []
            let holdItems = res.data.data; // 我持有的
            let holdItemsNew = []
            if (holdItems.length > 0) {
              holdItems.forEach((item) => { // number物品总数，numberOccupy已交接出去的，maxNumber可交接的
                item.goodsRemarks = ''
                if (item.numberOccupy === null) {
                  item.numberOccupy = 0
                }
                if (item.number != item.numberOccupy) {
                  item.maxNumber = item.number - item.numberOccupy
                  item.goodsType = 'holdItems'
                  holdItemsNew.push(item)
                }
              })
            }
            let holdItemsObj = {
              text: '我持有的',
              acctGoodsVO: holdItemsNew
            }
            newList.push(holdItemsObj)

            this.certificateList = newList
            if (storeGoodsList && storeGoodsList.length > 0) {
              storeGoodsList.forEach((item) => {
                newList.forEach((ite, index) => {
                  ite.acctGoodsVO.forEach((tt, ind) => {
                    if (tt.goodsId === item.goodsId) {
                      this.certificateList[index].acctGoodsVO[ind] = item
                    }
                  })
                })
              })
            }
            this.$nextTick(() => { // 默认选中上次选中的记录
              this.toggle()
            })
          }
        })
        .catch(() => {
          Toast("服务器错误，请联系账无忧解决!");
        });
    },
    sureFun () {
      console.log(this.result)
      let certificateList = this.certificateList
      let result = this.result
      if (result.length == 0) {
        localStorage.removeItem("storeGoodsList");
      } else {
        // 获取列表后处理
        let itemlist = []
        certificateList.forEach((item) => {
          itemlist = itemlist.concat(item.acctGoodsVO)
        })

        // 获取列表后处理
        let storeGoodsList = []
        result.forEach((item) => {
          itemlist.forEach((tt) => {
            if (item === tt.goodsId) {
              tt.goodsRemarks = ''
              storeGoodsList.push(tt)
            }
          })
        })

        // 与本地保存的对比-使用本地保存的备注
        let lsGoodsList = JSON.parse(localStorage.getItem("storeGoodsList"));
        if (lsGoodsList && lsGoodsList.length > 0) {
          storeGoodsList.forEach((item) => {
            lsGoodsList.forEach((tt) => {
              if (item.goodsId === tt.goodsId) {
                item.goodsRemarks = tt.goodsRemarks
              }
            })
          })
        }

        localStorage.setItem("storeGoodsList", JSON.stringify(storeGoodsList));
      }
      this.$router.go(-1);
    },
    checkboxChange () {
      console.log(this.result)
      let resultList = this.result
      if (resultList.length === this.toggleNumber) {
        this.toggleState = false
      }
      if (this.toggleState) return
      let acctGoodsList = this.certificateList[this.active].acctGoodsVO
      if (resultList.length === 0 ) {
        acctGoodsList.forEach((item) => {
          item.checked = false
          item.number = 1
        })
        return
      }
      acctGoodsList.forEach((item) => {
        resultList.forEach((tt) => {
          if (tt == item.goodsId) {
            item.checked = true
          }
        })
      })
    },
    // 初始化默认选中
    toggle() {
      this.toggleState = true
      console.log(this.certificateList, 2)
      let certificateList = this.certificateList

      // 获取列表后处理
      let itemlist = []
      certificateList.forEach((item) => {
        itemlist = itemlist.concat(item.acctGoodsVO)
      })

      let state = true
      itemlist.forEach((item, index) => {
        if (item.checked) {
          state = false
          this.$refs.checkboxes[index].toggle();
          this.toggleNumber++
        }
      })
      if (state) {
        this.toggleState = false
      }
    },
  },
  mounted: function() {
    // 获取本地保存的上次选中记录
    this.getGoodsList()
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.storeAdd {
    position: relative;
    height: 100%;

    .treeSelect-box {
      height: 100%;
      .van-tree-select {
        height: 100% !important;
      }
      .checkbox-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        margin-bottom: 0.2rem;
        height: 0.28rem;
      }
    }

    .btnRow {
        text-align: center;
        color: #1FADF6;
        background-color: #ffffff;
        border-top: 1px solid #f0f2f2;
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 0;
        font-size: 0.17rem;
        box-sizing: border-box;
        font-weight: 500;
        line-height: 0.52rem;
    }

    .btnRow.disabled {
        color: #B4BEC7;
    }
    .confirmText {
      color: #ffffff;
      height: 0.52rem;
      line-height: 0.52rem;
      background: #1fadf6;
    }
    .van-tree-select__content {
      flex: 3;
      padding: 0.2rem 0.1rem 0.52rem 0.1rem;
    }
    .van-tree-select__nav {
      padding-bottom: 0.52rem;
    }

    .empty {
      text-align: center;
      margin-top: 1.4rem;

      img {
        width: 0.8rem;
      }

      .desc {
        margin-top: 0.08rem;
        color: #B4BEC7;
        font-size: 0.12rem;
      }
    }
}
</style>
<style>
.storeAdd .van-stepper__minus,
.storeAdd .van-stepper__plus {
  border-radius: 0 2px 2px 0;
}
</style>

